import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class AccessibilityService {
    focusFirstInvalidField(formElement: HTMLElement): void {
        if (!formElement) return;
        setTimeout(() => {
            const invalidField = formElement.querySelector(
                'input.ng-invalid, select.ng-invalid, textarea.ng-invalid, ng-select.ng-invalid',
            ) as HTMLElement;

            if (invalidField?.tagName.toLowerCase() === 'ng-select') {
                const innerInput = invalidField.querySelector('input');
                if (innerInput) {
                    (innerInput as HTMLElement).focus();
                    return;
                }
            }

            invalidField?.focus();
        });
    }
}
